export default "__VITE_ASSET__u3QeS4hw__"